export const BIND_AFTER_LOGIN_FLAG = 'bindDomainMembership.afterLogin';
export const BIND_AFTER_LOGIN_QUERY_PARAM = 'bindAfterLogin';

/** Same prefix as `groupsKeys.all` in `useGroups.ts`. */
export const GROUPS_QUERY_KEY = ['groups'] as const;

export function pendingKey(id: number): string {
  return `bindDomainMembership.pending.${id}`;
}
